import { useMutation } from '@tanstack/react-query';
import { getAxiosInstance } from '../../../axiosInstances/axios';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';

// custom hook to use authentication functionalities declared here
const useAuthActions = () => {
  // declaring log in mutation function here
  const userLoginHandler = useMutation({
    mutationFn: async (body: {
      username_or_email: string;
      password: string;
    }): Promise<
      AcademiaResponse<{
        user_id: number;
        user_type: 'user' | 'client';
        access_token: string;
        refresh_token: string;
        is_first_login: boolean;
      } | null>
    > => {
      const response = await getAxiosInstance('user').post(
        '/user/login/',
        body
      );

      return response.data;
    },
  });

  // declaring log out mutation function here
  const userLogoutHandler = useMutation({
    mutationFn: async (): Promise<AcademiaResponse<null>> => {
      const response = await getPrivateAxiosInstance('user').post(
        '/user/logout/'
      );

      return response.data;
    },
  });

  // mutation function to fetch username with email declared here
  const getUserNameByEmailHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: { username_or_email: string };
    }): Promise<AcademiaResponse<string>> => {
      const response = await getAxiosInstance('user').post(
        '/user/full/name/with/email/or/username/',
        body
      );

      return response.data;
    },
  });

  return { userLoginHandler, userLogoutHandler, getUserNameByEmailHandler };
};

export default useAuthActions;
